package org.example.project.enginepersonal

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Style

enum class AnwesenheitsverwaltungPage {
    PERSONALVERWALTUNG,
    URLAUBSUEBERSICHT,
    ZEITVERWALTUNG,
    BUCHUNGSKLAERUNG,
    URLAUBSANTRAEGE,
    ZEITPROFILE,
    BUCHUNGSJOURNAL,
    STEMPELUHRGENERATOR
}

@Composable
fun AnwesenheitsverwaltungScreen(
    art: String,
    initialPage: AnwesenheitsverwaltungPage = AnwesenheitsverwaltungPage.URLAUBSUEBERSICHT
) {
    var selectedPage by remember(initialPage) { mutableStateOf(initialPage) }

    Style(AnwesenheitsverwaltungStyles)
    Div({ classes(AnwesenheitsverwaltungStyles.page) }) {
        Div({ classes(AnwesenheitsverwaltungStyles.tabs) }) {
            AnwesenheitsverwaltungTab("Personalverwaltung", selectedPage == AnwesenheitsverwaltungPage.PERSONALVERWALTUNG) { selectedPage = AnwesenheitsverwaltungPage.PERSONALVERWALTUNG }
            AnwesenheitsverwaltungTab(
                label = "Abwesenheitsübersicht",
                active = selectedPage == AnwesenheitsverwaltungPage.URLAUBSUEBERSICHT,
                onClick = { selectedPage = AnwesenheitsverwaltungPage.URLAUBSUEBERSICHT }
            )
            AnwesenheitsverwaltungTab("Abwesenheitsanträge", selectedPage == AnwesenheitsverwaltungPage.URLAUBSANTRAEGE) { selectedPage = AnwesenheitsverwaltungPage.URLAUBSANTRAEGE }
            AnwesenheitsverwaltungTab(
                label = "Zeit\u00fcbersicht",
                active = selectedPage == AnwesenheitsverwaltungPage.ZEITVERWALTUNG,
                onClick = { selectedPage = AnwesenheitsverwaltungPage.ZEITVERWALTUNG }
            )
            AnwesenheitsverwaltungTab(
                label = "Buchungskl\u00e4rung",
                active = selectedPage == AnwesenheitsverwaltungPage.BUCHUNGSKLAERUNG,
                onClick = { selectedPage = AnwesenheitsverwaltungPage.BUCHUNGSKLAERUNG }
            )
            AnwesenheitsverwaltungTab("Buchungsjournal", selectedPage == AnwesenheitsverwaltungPage.BUCHUNGSJOURNAL) { selectedPage = AnwesenheitsverwaltungPage.BUCHUNGSJOURNAL }
            AnwesenheitsverwaltungTab("Zeitprofile", selectedPage == AnwesenheitsverwaltungPage.ZEITPROFILE) { selectedPage = AnwesenheitsverwaltungPage.ZEITPROFILE }
            AnwesenheitsverwaltungTab("Stempeluhrgenerator", selectedPage == AnwesenheitsverwaltungPage.STEMPELUHRGENERATOR) { selectedPage = AnwesenheitsverwaltungPage.STEMPELUHRGENERATOR }
        }
        Div({ classes(AnwesenheitsverwaltungStyles.content) }) {
            when (selectedPage) {
                AnwesenheitsverwaltungPage.PERSONALVERWALTUNG -> PersonalverwaltungScreen(art)
                AnwesenheitsverwaltungPage.URLAUBSUEBERSICHT -> CUSUrlaubsuebersicht(art)
                AnwesenheitsverwaltungPage.ZEITVERWALTUNG -> CUSZeitverwaltung(art)
                AnwesenheitsverwaltungPage.BUCHUNGSKLAERUNG -> CUSBuchungsklaerung(art)
                AnwesenheitsverwaltungPage.URLAUBSANTRAEGE -> CUSAbwesenheitsantraege(art)
                AnwesenheitsverwaltungPage.ZEITPROFILE -> CUSZeitverwaltung(art, "Zeitprofile")
                AnwesenheitsverwaltungPage.BUCHUNGSJOURNAL -> BuchungsjournalScreen(art)
                AnwesenheitsverwaltungPage.STEMPELUHRGENERATOR -> StempeluhrGeneratorScreen()
            }
        }
    }
}

@Composable
private fun AnwesenheitsverwaltungTab(label: String, active: Boolean, onClick: () -> Unit) {
    LumaticaButton(
        label = label,
        onClick = onClick,
        variant = LumaticaButtonVariant.State,
        isActive = active,
        heightPx = 36
    )
}

private object AnwesenheitsverwaltungStyles : StyleSheet() {
    val page by style {
        width(100.percent)
        height(100.percent)
        minHeight(0.px)
        minWidth(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        color(Color.white)
        overflow("hidden")
        boxSizing("border-box")
    }
    val tabs by style {
        flexShrink(0)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        gap(8.px)
        flexWrap(FlexWrap.Wrap)
        padding(14.px, 22.px, 0.px)
    }
    val content by style {
        property("flex", "1 1 auto")
        minWidth(0.px)
        minHeight(0.px)
        overflow("hidden")
    }
}
